<template>
  <section>
    <el-table
      :data="subOperateDataLogList"
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column fixed="left" type="index" label="序号" width="60"></el-table-column>
      <el-table-column fixed="left" prop="OperatorType" label="操作项" width="80"></el-table-column>
      <el-table-column prop="ParentEntityDescription" label="父表" width="150"></el-table-column>
      <!-- <el-table-column prop="ParentEntityKey" label="父表Id" width="80"></el-table-column> -->
      <el-table-column prop="EntityDescription" label="当前表" width="150"></el-table-column>
      <el-table-column prop="EntityKey" label="当前表Id" width="80"></el-table-column>
      <el-table-column prop="FieldDescription" label="字段描述" width="150"></el-table-column>
      <el-table-column prop="OldValue" :formatter="isTimeFormat" label="旧值" width="180"></el-table-column>
      <el-table-column prop="NewValue" :formatter="isTimeFormat" label="新值" width="180"></el-table-column>
      <el-table-column fixed="right" prop="OperatorName" label="操作人" width="120"></el-table-column>
      <el-table-column fixed="right" prop="OperatorTime" label="操作时间" width="160"></el-table-column>
      </el-table>
      <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>
  </section>
</template>

<script>
import util from "../../util/date";
import { getSubOperateDataLogListPage } from "../api/api";

export default {
  data() {
    return {
      subOperateDataLogList:[],//子表操作日记列表
      total: 0,
      page: 1,
      pageSize: 10
    };
  },
  props: {
    busLinesId: {
      type: Number,
      default: 0
    },
    parentEntityName: {
      type: String,
      default: ''
    },
    parentEntityKey: {
      default: ''
    }
  },
  methods: {
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getSubOperateDataLogList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getSubOperateDataLogList();
    },
    isTimeFormat: function(row, column) {
      if(row.FieldDescription === "发车时间"){
        return !row[column.property] || row[column.property] === ""
            ? ""
            : util.formatDate.format(new Date(row[column.property]), "hh:mm");
      } else if (row.DataType === "DateTime"){
        return !row[column.property] || row[column.property] === ""
          ? ""
          : util.formatDate.format(new Date(row[column.property]), "yyyy-MM-dd hh:mm:ss");
      } else if (row.DataType === "" && isNaN(row[column.property]) && !isNaN(Date.parse(row[column.property]))){
        return !row[column.property] || row[column.property] === ""
          ? ""
          : util.formatDate.format(new Date(row[column.property]), "yyyy-MM-dd hh:mm:ss");
      }

      return row[column.property];
    },
    getSubOperateDataLogList(){
      let _this = this;
      _this.subOperateDataLogList = [];
      let para = {
        parentEntityName: _this.parentEntityName,
        parentEntityKey: _this.parentEntityKey,
        busLinesId: _this.busLinesId,
        page: _this.page,
        pageSize: _this.pageSize
      };
      getSubOperateDataLogListPage(para).then(res => {
        _this.total = res.data.response.dataCount;
        _this.subOperateDataLogList = res.data.response.data;
      });
    }
  },
  mounted() {
    this.page = 1;
    this.getSubOperateDataLogList();
  }
}
</script>
